import { FC } from 'react';
import { format } from 'date-fns';

import { dateFormat } from 'constants/formats';
import { getDocumentIcon } from 'utils/documentIcons';
import { Document } from 'types';
import DocumentsColumn from 'modules/_shared/components/DocumentsColumn';
import ToggleMenu from 'modules/_shared/components/ToggleMenu';
import { useTranslate } from 'hooks/useTranslate';
import { getToggleOptions } from '../utils/getToggleOptions';

type DocumentsTableRowProps = {
  index: number;
  document: Document;
  handleRemoveDocument?: (document: Document) => void;
  handleReplaceDocument?: (document: Document) => void;
};

const DocumentsTableRow: FC<DocumentsTableRowProps> = ({
  index,
  document,
  handleRemoveDocument,
  handleReplaceDocument,
}) => {
  const { t } = useTranslate();

  const documentIcon = getDocumentIcon(document, false);
  const documentName = document?.name || '';
  const documentDescription = document?.description || '';
  const documentDate = document?.date
    ? format(new Date(document.date), dateFormat)
    : '-';

  const hasOptions = !!handleRemoveDocument || !!handleReplaceDocument;

  const handleRemove = () => {
    if (handleRemoveDocument) {
      handleRemoveDocument(document);
    }
  };

  const handleReplace = () => {
    if (handleReplaceDocument) {
      handleReplaceDocument(document);
    }
  };

  const toggleOptions = getToggleOptions({
    index,
    hasRemoveOption: !!handleRemoveDocument,
    hasReplaceOption: !!handleReplaceDocument,
    handleTranslate: t,
    handleRemove,
    handleReplace,
  });

  return (
    <>
      <td
        className="align-content-center nk-file-title"
        key={`document-name-${index}`}
      >
        <span className="nk-file-icon">
          <span className="nk-file-icon-type">
            <img src={documentIcon} alt="icon-file" />
          </span>
        </span>

        <span className="nk-file-name d-flex flex-column">
          <span className="text-ellipsis">{documentName}</span>
          <span className="fw-light text-muted text-ellipsis fs-12px">
            {documentDescription}
          </span>
        </span>
      </td>

      <td
        className="nk-file-meta d-none d-xl-table-cell align-content-center"
        key={`document-date-${index}`}
      >
        <span>{documentDate}</span>
      </td>

      <td
        className="nk-file-meta d-none d-xl-table-cell align-content-center text-right"
        key={`document-options-${index}`}
      >
        <DocumentsColumn
          index={index}
          documentsCount={1}
          documents={[document]}
          tableView={false}
          hideOnMobile={false}
        />
      </td>

      {hasOptions && (
        <td
          className="nk-file-meta d-none d-xl-table-cell align-middle text-center"
          key={`documet-options-${index}`}
        >
          <ToggleMenu toggleOptions={toggleOptions} />
        </td>
      )}
    </>
  );
};

export default DocumentsTableRow;
